import React, { useEffect, useRef, useState } from "react";

//design imports from material
import {
  Grid,
  TextField,
  FormControl,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Tooltip,
  Autocomplete,
  IconButton,
} from "@mui/material"; 

//layout import
import Layout from "../../../layout/Layout";
import dayjs from "dayjs";
import axios from "axios";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";

//form imports
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";

import {
  config,
  _numberOnly,
  projectMasterAPI,
  statusMasterAPI,
  vendorAPI,
  purchaseOrderAPI,
  termsAndConditionsAPI,
  userData,
  manageCompaniesAPI,
  purchaseOrderItemsAPI,
  handleHrMasterAPI,
} from "../../../config";
import { AlertMessage } from "../../../components/AlertMessage";
import { getValue } from "@mui/system";
import NavigationGuard from "../../../layout/NavigationGuard";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// const names = ["KG Terms & Conditions", "Validity"];
let total = 0;
let cgst = 0;
let igst = 0;
let sgst = 0;
let totalAmount = 0;

function PurchaseOrderEdit() {
  const { POid } = useParams();
  const childRef = useRef();
  const navigate = useNavigate();

  // add field
  const [serviceList, setServiceList] = useState([
    { txtItemName: "", txtUnits: "", txtDiscountType: "percentage" },
  ]);
  const [totalWithoutGST, setTotalWithoutGST] = useState(0);
  const [totalCgst, settotalCgst] = useState(0);
  const [totalSgst, setTotalSgst] = useState(0);
  const [totalIgst, setTotalIgst] = useState(0);
  const [totalamount, setTotalAmount] = useState(0);
  const [txtSiteEng, setTextSiteEng] = useState("");
  const [deletedItems, setDeletedItems] = useState([]);

  const [deletedList, setDeletedList] = useState(null);

  const handleServiceRemove = (index) => {
    const list = [...serviceList1];
    const removedItem = list[index];
    const deletedId = removedItem.intID;

    removedItem.intStatus = 1;
    setDeletedItems((prevDeletedItems) => [...prevDeletedItems, deletedId]);

    list.splice(index, 1);
    setServiceList1(list);
    handleServiceChangeAfterRemove(list, removedItem);
  };

  const handleServiceChangeAfterRemove = (updatedList, removedItem) => {
    let igst = 0;
    let cgst = 0;
    let sgst = 0;
    // let total = 0;
    let totalAmount = 0;

    updatedList.forEach((item) => {
      let tempGST = parseInt(item["intGST"]) / 2;

      item["intLineItemTotalWithoutGST"] =
        parseInt(item["intAmount"]) * parseInt(item["intQuantity"]);

      if (vendorDetails.state != "TamilNadu") {
        item["intIGST"] =
          (tempGST / 100) * item["intLineItemTotalWithoutGST"] +
          (tempGST / 100) * item["intLineItemTotalWithoutGST"];
        item["intCGST"] = 0;
        item["intSGST"] = 0;
      } else {
        item["intCGST"] = (tempGST / 100) * item["intLineItemTotalWithoutGST"];
        item["intSGST"] = (tempGST / 100) * item["intLineItemTotalWithoutGST"];
        item["intIGST"] = 0;
      }

      item["intTGST"] = item["intCGST"] + item["intSGST"] + item["intIGST"];

      item["intLineItemTotalWithGST"] =
        item["intLineItemTotalWithoutGST"] + item["intTGST"];

      igst += item["intIGST"] || 0;
      cgst += item["intCGST"] || 0;
      sgst += item["intSGST"] || 0;
      totalAmount += item["intLineItemTotalWithGST"] || 0;
      // total += item["intLineItemTotalWithoutGST"] || 0;
    });

    total = totalWithoutGST - removedItem.intLineItemTotalWithoutGST;
    setTotalWithoutGST(
      (prevTotal) => prevTotal - removedItem.intLineItemTotalWithoutGST,
    );
    settotalCgst(cgst);
    setTotalSgst(sgst);
    setTotalIgst(igst);
    setTotalAmount(totalAmount + transportCharge);
  };

  const [unitsFlag, setUnitsFlag] = useState(false);

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;

    const list = [...serviceList1];

    list[index][name] = value;

    const withGST = list[index]["blnWithGST"] === true;
    const gstRateFull = withGST ? 0 : parseInt(list[index]["intGST"] || 0);
    
    let tempGST = gstRateFull / 2;
    
    let baseRate = parseFloat(list[index]["intAmount"] || 0);
    
    let qty = parseFloat(list[index]["intQuantity"]);
    if (isNaN(qty)) qty = 1;
    const rawSubtotal = baseRate * qty;

    // Apply per-item discount before GST
    const discountType = list[index]["txtDiscountType"] || "";
    const discountValue = parseFloat(list[index]["fltDiscountValue"]) || 0;
    let discountedSubtotal = rawSubtotal;
    if (discountType === "fixed") {
      discountedSubtotal = Math.max(0, rawSubtotal - discountValue);
    } else if (discountType === "percentage") {
      const pct = Math.min(100, Math.max(0, discountValue));
      discountedSubtotal = rawSubtotal * (1 - pct / 100);
    }
    list[index]["intLineItemTotalWithoutGST"] = discountedSubtotal;

    if (vendorDetails.state != "TamilNadu") {
      list[index]["intIGST"] =
        (tempGST / 100) * discountedSubtotal +
        (tempGST / 100) * discountedSubtotal;
    } else {
      list[index]["intCGST"] = (tempGST / 100) * discountedSubtotal;
      list[index]["intSGST"] = (tempGST / 100) * discountedSubtotal;
    }

    list[index]["intTGST"] = list[index]["intCGST"] + list[index]["intSGST"];

    if (vendorDetails.state != "TamilNadu") {
      list[index]["intLineItemTotalWithGST"] =
        discountedSubtotal + list[index]["intIGST"];
    } else {
      list[index]["intLineItemTotalWithGST"] =
        discountedSubtotal + list[index]["intCGST"] + list[index]["intSGST"];
    }

    igst = 0;
    cgst = 0;
    sgst = 0;
    total = 0;
    totalAmount = 0;

    list.forEach((item) => {
      if (item.hasOwnProperty("intCGST")) {
        cgst = cgst + (item["intCGST"] || 0);
      }

      if (item.hasOwnProperty("intSGST")) {
        sgst = sgst + (item["intSGST"] || 0);
      }

      if (item.hasOwnProperty("intIGST")) {
        igst = igst + (item["intIGST"] || 0);
      }

      if (item.hasOwnProperty("intLineItemTotalWithGST")) {
        totalAmount = totalAmount + (item["intLineItemTotalWithGST"] || 0);
      }

      if (item.hasOwnProperty("intLineItemTotalWithoutGST")) {
        total = total + (item["intLineItemTotalWithoutGST"] || 0);
      }
    });

    setTotalWithoutGST(total);
    setServiceList1(list);
    setDeletedList(list);

    if (igst > 0) {
      settotalCgst(0);
      setTotalSgst(0);
      setTotalIgst(igst);
    } else {
      setTotalIgst(0);
      settotalCgst(cgst);
      setTotalSgst(sgst);
    }

    setTotalAmount(totalAmount + transportCharge);
  };

  const handleServiceAdd = () => {
    setServiceList1([
      ...serviceList1,
      { txtItemName: "", txtUnits: "", txtDiscountType: "percentage", blnWithGST: false },
    ]);

    setDeletedList([
      ...deletedList,
      { txtItemName: "", txtUnits: "", txtDiscountType: "percentage", blnWithGST: false },
    ]);
  };

  const validationSchema = Yup.object().shape({
    // txtCompanyName: Yup.string().required("Company Name is required"),
    // intVendorID: Yup.string().required("Vendor Name is required"),
    // intProjectID: Yup.string().required("Project Name is required"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);

  const { errors } = formState;

  const [PoDate, setPoDate] = React.useState(dayjs().format("YYYY-MM-DD"));

  // Vendor List
  const [vendorList, setVendorList] = useState([]);

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 3,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = vendorAPI;

      axios(config)
        .then(function (response) {
          // return;
          setVendorList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });

      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  let tempRefs = useRef(false);

  const [companyName, setCompanyName] = React.useState("");

  //Marital Details
  const [ProjectNameList, setProjectNameList] = useState([]);

  const [intProjectID, setProjectName] = useState(0);
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 6,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = projectMasterAPI;

      axios(config)
        .then(function (response) {
          setProjectNameList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  //Terms Of Payments
  const [termsofPayments, setTermsofPayments] = useState([]);
  // const [txtTermsOfPayments, setTermsofPayment] = useState("");
  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 59,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setTermsofPayments(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  // dispatch
  const [dispatch, setDispatch] = useState([]);
  const [txtDispatchThrough, setDispatchThrough] = useState("");
  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 65,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setDispatch(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  // UnitList
  const [unitsList, setUnitsList] = useState([]);
  const [units, setUnits] = useState("");
  tempRefs.current = false;
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 88,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setUnitsList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  // Purchase
  const [Purchase, setPurchase] = useState([]);
  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 68,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setPurchase(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  tempRefs.current = false;

  // Vendor Details
  const [vendorDetails, setVendorDetails] = useState({});
  const [intVendorID, setVendorID] = useState(0);

  const handleVendor = (id) => {
    const data = {
      intType: 7,
      intvendorAutoID: id,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = vendorAPI;

    axios(config)
      .then(function (response) {
        setVendorDetails(response.data.result[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  tempRefs.current = false;

  // Purchase
  const [termsNames, setTermsNames] = useState([]);

  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 4,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = termsAndConditionsAPI;

      axios(config)
        .then(function (response) {
          setTermsNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  tempRefs.current = false;

  // const [termsName, setTermsName] = useState("");
  const [terms, setTermsandConditions] = useState("");
  const [termsDescription, setTermsDescription] = useState(null);

  const handleChangeterm = (event) => {
    setPOTerm(event.target.value);
    setTermsHeading(event.target.value);

    const data = {
      intType: 3,
      intID: event.target.value,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = termsAndConditionsAPI;

    axios(config)
      .then(function (response) {
        setTermsandConditions(response.data.result[0]);
        const fetchedDescription = response.data.result[0]?.description || "";
        setValue("txtTerms", fetchedDescription);
        setTermsDescription(response.data.result[0].description);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // useEffect(() => {
  //   const initTinyMCE = () => {
  //     const textareaElement = document.getElementById("textarea");

  //     if (textareaElement && termsDescription !== null) {
  //       window.tinymce.init({
  //         selector: "#textarea",
  //         width: "100%",
  //         menubar: false,
  //         plugins:
  //           "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount",
  //         toolbar:
  //           "undo redo | fontsize | bold italic underline strikethrough | align lineheight | numlist bullist indent outdent",
  //       });

  //       setTimeout(function () {
  //         window.tinymce.get("textarea").setContent(termsDescription);
  //       }, 1500);
  //     }
  //   };

  //   const timeoutId = setTimeout(initTinyMCE, 500);

  //   return () => {
  //     clearTimeout(timeoutId);
  //     if (window.tinymce.get("textarea")) {
  //       window.tinymce.remove();
  //     }
  //   };
  // }, [termsDescription]);

  // axios(config)
  // .then(function (response) {

  //   setTermsNames(response.data.result[0].title);
  //   window.tinymce.init({
  //     selector: "#textarea",
  //     width: "100%",
  //     menubar: false,
  //     plugins:
  //       "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount",
  //     toolbar:
  //       "undo redo | fontsize | bold italic underline strikethrough | align lineheight | numlist bullist indent outdent",
  //   });
  //   setTimeout(function () {
  //     window.tinymce
  //       .get("textarea")
  //       .setContent(response.data.result[0].description);
  //   }, 1150);
  // })

  const [transportGST, setTransportGST] = useState(0);
  const [transportAmount, setTransportAmount] = useState(0);
  const [transportCharge, setTransportCharge] = useState(0);

  const [transportTotal, setTransportTotal] = useState(0);

  const handleTransportCharge = (amountText, gstText) => {
    // Treat empty string as 0
    const amt = amountText === "" ? 0 : parseFloat(amountText) || 0;
    const gstRate = gstText === "" ? 0 : parseFloat(gstText) || 0;

    const gstValue = (amt * gstRate) / 100;
    const trCharge = amt + gstValue;

    setTransportCharge(trCharge);
    setTransportTotal(trCharge); // Just mimicking the other states if needed

    // Total Amount overall = sum of line items + transportCharge
    // In React 18, setTotalAmount(total + trCharge) normally relies on a separate `totalAmountWithoutTransport`
    // but calculating it from items here manually is safer:

    let currentItemsTotal = 0;
    serviceList1.forEach((item) => {
      if (item.hasOwnProperty("intLineItemTotalWithGST") && !item.intStatus) {
        currentItemsTotal += parseFloat(item["intLineItemTotalWithGST"] || 0);
      }
    });

    setTotalAmount(currentItemsTotal + trCharge);
  };

  const [baseuploadagreement, setBaseUploadAgreement] = useState("");

  const uploadagreement = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseUploadAgreement(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const [companyNames, setCompanyNames] = React.useState("");
  // getting all companies
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 5,
        // intParentId: 42,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = manageCompaniesAPI;

      axios(config)
        .then(function (response) {
          setCompanyNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const twoDecimal = (x) => {
    return Number.parseFloat(x).toFixed(2);
  };

  // getting the PO data
  const [poNo, setPoNo] = useState(null);
  useEffect(() => {
    if (tempRefs.current === false && companyNames.length > 0) {
      const data = {
        intType: 4,
        intPOId: POid,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = purchaseOrderAPI;

      axios(config)
        .then(function (response) {
          const poData = response.data.result[1][0];
          setPoNo(poData.po_no);

          // setPoNo(response.data.result[1][0].po_no);

          const numericCompanyId = Number(
            poData.company_name || poData.txtCompanyName,
          );
          setCompanyName(numericCompanyId);

          const initialProjectId = poData.project_id;
          const projectExists = ProjectNameList.some(
            (p) => p.id === initialProjectId,
          );

          if (projectExists) {
            setProject(initialProjectId);
          } else {
            console.warn("Initial project not found in ProjectNameList");
            setProject(""); // Reset if not found
          }

          const addressTypeValue =
            poData.address_type === 2 ? "branch" : "default";
          setAddressType(addressTypeValue);

          if (addressTypeValue === "branch") {
            const matchedCompany = companyNames.find(
              (comp) => Number(comp.id) === numericCompanyId,
            );

            setCompanyInfo(matchedCompany);
          }

          // handleFormReset(response.data.result[1][0]);
          // fetchProjectDetails(response.data.result[1][0].project_id);

          handleFormReset(poData);
          fetchProjectDetails(poData.project_id);

          // roundUpToInteger()

          // setPoData(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, [companyNames]);

  const [projectDetails, setProjectDetails] = useState([]);

  // Fetching project details
  const fetchProjectDetails = (projectID) => {
    if (projectID === 0) {
      return;
    }

    const data = {
      intType: 2,
      intProjectID: projectID,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = projectMasterAPI;

    axios(config)
      .then((response) => {
        // setProjectDetails(response.data.result[0]);
        const projectData = response.data.result[0];
        setProjectDetails(projectData);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [serviceList1, setServiceList1] = useState([]);

  // PO items data
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 3,
        intPONo: POid,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = purchaseOrderItemsAPI;

      axios(config)
        .then(function (response) {
          const sortedResult = [...response.data.result].sort((a, b) => (a.intID || a.id || 0) - (b.intID || b.id || 0));
          const adjustedResult = sortedResult.map(item => {
            const amount = parseFloat(item.intAmount || 0);
            const quantity = parseFloat(item.intQuantity || 0);
            const gstRate = parseFloat(item.intGST || 0);
            const savedWithoutGST = parseFloat(item.intLineItemTotalWithoutGST || 0);
            
            let isWithGST = false;
            
            // For older records where the math extraction was used
            if (gstRate > 0) {
              const baseRateWithGST = amount / (1 + (gstRate / 100));
              const rawSubWith = baseRateWithGST * quantity;
              const discType = item.txtDiscountType || "";
              const discVal = parseFloat(item.fltDiscountValue || 0);
              const applyDisc = (raw) => {
                if (discType === "fixed") return Math.max(0, raw - discVal);
                if (discType === "percentage") return Math.max(0, raw - (raw * discVal) / 100);
                return raw;
              };
              const calcWith = applyDisc(rawSubWith);
              const calcWithout = applyDisc(amount * quantity);
              if (Math.abs(savedWithoutGST - calcWith) < Math.abs(savedWithoutGST - calcWithout)) {
                isWithGST = true;
              }
            } else {
              isWithGST = false;
            }
            return {
              ...item,
              blnWithGST: isWithGST
            };
          });
          setServiceList(adjustedResult);
          setServiceList1(adjustedResult);
          setDeletedList(adjustedResult);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const [orderType, setOrderType] = useState("");
  const [vendorName, setVendorName] = useState("");
  // const [companyName, setCompanyName] = useState("")
  const [project, setProject] = useState("");
  const [termsOfPayment, setTermsOfPayment] = useState(0);
  const [purchaseClassify, setPurchaseClassify] = useState("");
  const [termsHeading, setTermsHeading] = useState("");
  const [validUpto, setValidUpto] = React.useState(
    dayjs().format("YYYY-MM-DD"),
  );

  // const [transportGst, setTransportGst] = React.useState("")
  const [termBody, setTermBody] = React.useState("");

  const [comingFile, setComingFile] = React.useState("");

  const handleFormReset = (data) => {
    let defaultValues = {};

    total = data.total_without_gst;
    cgst = data.total_cgst;
    igst = data.total_igst;
    sgst = data.total_sgst;
    handleVendor(data.vendor_id);
    setOrderType(data.order_type);
    setVendorName(data.vendor_id);
    setCompanyName(data.company_name);
    setProject(data.project_id);
    setTermsOfPayment(data.terms_of_payment);
    setPurchaseClassify(data.purchase_classfication);
    setTermsHeading(data.terms_heading);
    setTransportGST(data.transport_gst);
    setTotalWithoutGST(data.total_without_gst);
    setTotalAmount(data.total_with_gst);
    setTransportAmount(data.transport_amount);
    setTransportCharge(data.transport_charge);
    setValidUpto(data.po_validate_upto);
    setTermBody(data.terms);
    settotalCgst(data.total_cgst);
    setTotalSgst(data.total_sgst);
    setTotalIgst(data.total_igst);
    setTermsandConditions(data.terms);
    setTextSiteEng(data.site_engineer);
    setTermsDescription(data.terms);
    const address = JSON.parse(data.address) || "";
    console.log("address", data);
    if (address) {
      if (address.type == 1) {
        setAddressType("default");
        setSelectedAddress(data.project_address);
      } else if (address.type == 2) {
        setAddressType("branch");
        setSelectedAddress(address.address);
      }
    }

    if (data.file != "" || data.file != null) {
      setBaseUploadAgreement(data.file);
    }

    defaultValues.txtSiteEngContact = data.site_eng_contact;
    defaultValues.txtOrderType = data.order_type;
    defaultValues.intVendorID = data.vendor_id;
    defaultValues.txtCompanyName = data.company_name;
    defaultValues.intProjectID = data.project_id;
    defaultValues.txtTermsOfPayments = data.terms_of_payment;
    defaultValues.txtQuotationNo = data.quotation_no;
    defaultValues.txtPurchaseClassify = data.purchase_classfication;
    defaultValues.txtPOValidTo = data.po_validate_upto;
    defaultValues.intTransportGST = data.transport_gst;
    defaultValues.intTransportAmount = data.transport_charge;
    defaultValues.intTransportCharge = data.transport_charge;
    defaultValues.txtTerms = data.terms;
    defaultValues.txtTermsHeading = data.terms_heading;

    if (data.po_date) {
      setPoDate(data.po_date);
    }

    setTimeout(function () {
      reset({ ...defaultValues });
    }, 3000);
  };

  // const editorRef = useRef(null);
  // useEffect(() => {
  //   window.tinymce.init({
  //     selector: "#textarea",
  //     width: "100%",
  //     menubar: false,
  //     setup: (editor) => {
  //       editorRef.current = editor;

  //       // Set the initial content of the editor
  //       editor.on('init', () => {
  //         editor.setContent(``);
  //       });
  //     },
  //     plugins:
  //       "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount",
  //     toolbar:
  //       "undo redo | fontsize | bold italic underline strikethrough | align lineheight | numlist bullist indent outdent",
  //   })

  // }, [])

  const [PoTerm, setPOTerm] = React.useState(0);

  function onSubmit(data) {
    // editing text area items
    const isInvalid = (value) => value === null || value === 0 || value === "";

    if (
      isInvalid(data.txtOrderType) ||
      isInvalid(data.txtCompanyName) ||
      isInvalid(data.intVendorID) ||
      isInvalid(data.intProjectID) ||
      // isInvalid(data.txtTermsOfPayments) ||
      isInvalid(data.txtPurchaseClassify) ||
      isInvalid(data.txtSiteEng)
    ) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "Please enter the required fields",
          messageType: "error",
        }),
      );
      return;
    }

    if (
      PoTerm == 0 &&
      (data.txtTermsHeading === null || data.txtTermsHeading === "")
    ) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "Terms & Conditions is required",
          messageType: "error",
        }),
      );
      return;
    }

    if (deletedList.length <= 0) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "At least 1 PO Item is required",
          messageType: "error",
        }),
      );
      return;
    } else {
      const invalidIndex = deletedList.findIndex((item) => {
        return (
          isNaN(item.intLineItemTotalWithGST) ||
          item.intLineItemTotalWithGST === ""
        );
      });

      if (invalidIndex !== -1) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: `Fill all the details at S.no ${invalidIndex + 1}`,
            messageType: "error",
          }),
        );
        return;
      }
    }

    // let finalPoDesc = "";
    // let poDesc = window.tinymce.get("textarea")?.getContent();
    // if (poDesc) {
    //   let newPoDesc = poDesc.replaceAll("<p>", "");
    //   finalPoDesc = newPoDesc.replaceAll("</p>", "");
    // }
    // let finalPoDesc = termBody || "";

    data.txtPONumber = poNo;
    data.txtPODate = PoDate;
    data.txtFile = baseuploadagreement;
    data.lineItems = deletedList;
    // return
    data.intTotalWithoutGST = totalWithoutGST;
    data.intTotalIGST = totalIgst;
    data.intTotalSGST = totalSgst;
    data.intTotalCGST = totalCgst;

    // if (totalIgst > 0) {
    //   data.intTotalSGST = 0;
    //   data.intTotalCGST = 0;
    //   data.intTotalIGST = totalIgst;
    // } else if (totalCgst > 0 && totalSgst > 0) {
    //   data.intTotalIGST = 0;
    //   data.intTotalSGST = totalSgst;
    //   data.intTotalCGST = totalCgst;
    // }
    data.txtPOValidTo = validUpto;
    data.intTotalWithGST = totalamount;
    data.intCreatedBy = userData.emp_id;
    data.txtSiteEng = txtSiteEng;
    if (intVendorID) {
      data.intVendorID = intVendorID;
    } else {
      data.intVendorID = vendorName;
    }

    data.intStatus = 98;
    data.intTransportGst = transportGST;
    data.intTransportAmount = transportAmount;
    data.intTransportCharge = transportCharge;

    if (PoTerm != 0) {
      data.txtTermsHeading = PoTerm;
    } else {
      data.txtTermsHeading = termsHeading;
    }
    if (data.txtTerms && data.txtTerms.trim() !== "") {
      data.txtTerms = data.txtTerms.trim();
    } else {
      data.txtTerms = termBody || "";
    }
    data.txtCompanyName = companyName;
    data.intType = 6;
    data.intPOId = POid;

    const address = {
      type: addressType === "branch" ? 2 : addressType === "default" ? 1 : 1,
      address: addressType === "branch" ? selectedAddress : "",
    };
    data.txtAddress = JSON.stringify(address);

    if (deletedList.length > 0) {
      data.deletedListIds = deletedItems;
    }

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = purchaseOrderAPI;
    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          }),
        );

        setTimeout(function () {
          navigate(`/purchase-order/list`);
        }, 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [siteEngineer, setSiteEngineer] = useState([]);

    useEffect(() => {
      if (tempRefs.current === false) {
        const data = {
          intType: 12, // Changed from 9 to 12
        };

        config.method = "POST";
        config.data = JSON.stringify(data);
        config.url = handleHrMasterAPI;

        axios(config)
          .then(function (response) {
            setSiteEngineer(response.data.result);
          })
          .catch(function (error) {
            console.log(error);
          });
        return () => {
          tempRefs.current = true;
        };
      }
    }, []);


  const findPhoneNumber = (id) => {
    const contact = siteEngineer.find((person) => person.id === id);
    contact && setValue("txtSiteEngContact", contact.phone_no);
  };

  function calculateRoundingDifference(value) {
    // Round up to the nearest integer
    const roundedValue = Math.ceil(value);

    // Calculate the rounding difference
    const difference = roundedValue - value;

    return difference.toFixed(2);
  }

  function roundUpToInteger(value) {
    // Round up to the nearest integer
    const roundedValue = Math.ceil(value);

    // Append ".00" to the rounded value
    const formattedValue = roundedValue.toFixed(2);

    return formattedValue;
  }

  const [isCancelPopup, setIsCancelPopup] = useState(false);

  const handleCancelFile = async () => {
    setBaseUploadAgreement("");
    document.getElementById("agreementdocument").value = "";
    setIsCancelPopup(false);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [addressType, setAddressType] = useState("default");
  const [autoOpen, setAutoOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");

  const [companyInfo, setCompanyInfo] = useState(null);

  const handleCompanyFieldClick = () => {
    setAutoOpen(true);
  };

  const handleAutoCompleteClose = () => {
    setAutoOpen(false);
  };

  const handleProjectSelection = (newValue, isSameProject = false) => {
    if (!newValue || typeof newValue !== "object") return;

    const projectId = newValue.id;

    // Only skip if project is same AND we're not forcing it
    if (projectId === project && !isSameProject) return;

    setProjectName(projectId);
    setValue("intProjectID", projectId);

    const selectedProject = ProjectNameList.find((p) => p.id === projectId);
    if (!selectedProject) return;

    setProjectDetails(selectedProject);

    // Check if company is 22 or 31
    const numericCompanyId = Number(companyName);
    if ([22, 31].includes(numericCompanyId)) {
      setDialogOpen(true);
    }
  };

  const handleProjectChange = (selectedProjectId) => {
    const selectedProject = ProjectNameList.find(
      (proj) => proj.id === selectedProjectId,
    );

    if (selectedProject) {
      // Always update project info
      setProject(selectedProjectId);
      fetchProjectDetails(selectedProjectId);
      setProjectName(selectedProjectId);
      setValue("intProjectID", selectedProjectId);

      // Always clear previous address first
      setSelectedAddress("");

      // If company is 22 or 31, force dialog open
      if ([22, 31].includes(Number(companyName))) {
        setDialogOpen(true);
      } else {
        setAddressType("default");
        setSelectedAddress(selectedProject.project_address || "");
      }
    }
  };

  const GST_RATES = [0, 5, 12, 18, 40];

  return (
    <Layout>
      <AlertMessage ref={childRef} />
      <Grid className="employee-form">
        <Grid item xs={12} lg={12} md={12}>
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                {orderType == 1
                  ? "Purchase Order"
                  : orderType == 2
                    ? "Work Order"
                    : "Purchase Order"}
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">
                  {" "}
                  {orderType == 1
                    ? "Purchase Order"
                    : orderType == 2
                      ? "Work Order"
                      : "Purchase"}
                </Typography>
                <Typography color="text.primary">edit</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              textAlign="right"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="secondary"
                className="button_first"
                href="/purchase-order/list"
              >
                List{" "}
                {orderType == 1
                  ? "Purchase Order"
                  : orderType == 2
                    ? "Work Order"
                    : "Purchase Order"}
              </LoadingButton>
              {/* <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </LoadingButton> */}
            </Grid>
          </Grid>
        </Grid>
        <div className="empty-space-40"></div>
        <Grid className="purchaseorder">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container className="popading" spacing={2}>
              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth>
                  <Autocomplete
                    options={[
                      { id: "1", name: "Purchase Order" },
                      { id: "2", name: "Work Order" },
                    ]}
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      [
                        { id: "1", name: "Purchase Order" },
                        { id: "2", name: "Work Order" },
                      ].find(
                        (order) => String(order.id) === String(orderType),
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue === "object") {
                        setValue("txtOrderType", newValue.id || "");
                        setOrderType(newValue.id || "");
                      } else {
                        setValue("txtOrderType", "");
                        setOrderType("");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Order Type"
                        placeholder="Search Order Type"
                        variant="outlined"
                      />
                    )}
                  />
                  <Typography className="invalid-feedback">
                    {errors.txtOrderType?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth>
                  <Autocomplete
                    options={vendorList ?? []}
                    getOptionLabel={(option) =>
                      option?.name ? `${option.name} (${option.id})` : ""
                    }
                    value={
                      (vendorList ?? []).find(
                        (vendor) =>
                          String(vendor.id) === String(vendorName) ||
                          String(vendor.id) === String(intVendorID),
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue === "object") {
                        handleVendor(newValue.id || "");
                        setVendorID(newValue.id || "");
                        setVendorName(newValue.id || "");
                        setValue("intVendorID", newValue.id || "");
                      } else {
                        setVendorID("");
                        setVendorName("");
                        setValue("intVendorID", "");
                        setVendorDetails({});
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vendor Name"
                        placeholder="Search Vendor"
                        variant="outlined"
                      />
                    )}
                  />
                  <Typography className="invalid-feedback">
                    {errors.intVendorID?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth>
                  <Autocomplete
                    options={Array.isArray(companyNames) ? companyNames : []}
                    getOptionLabel={(option) => option?.company_name || ""}
                    value={
                      Array.isArray(companyNames)
                        ? companyNames.find(
                            (company) =>
                              String(company.id) === String(companyName),
                          ) || null
                        : null
                    }
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue === "object") {
                        setCompanyName(newValue.id || "");
                        setValue("txtCompanyName", newValue.id || "");
                      } else {
                        setCompanyName("");
                        setValue("txtCompanyName", "");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Company Name"
                        placeholder="Search Company"
                        variant="outlined"
                      />
                    )}
                  />
                  <Typography className="invalid-feedback">
                    {errors.txtCompanyName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle
                  sx={{
                    m: 0,
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Select Address Type
                  <IconButton
                    aria-label="close"
                    onClick={() => setDialogOpen(false)}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                  <Typography sx={{ mb: 2 }}>
                    Please choose whether you want the default Project address
                    or the Custom address.
                  </Typography>
                  <RadioGroup
                    value={addressType}
                    onChange={(e) => {
                      const selectedType = e.target.value;
                      setAddressType(selectedType);

                      if (selectedType === "default") {
                        if (projectDetails?.project_address) {
                          setSelectedAddress(projectDetails.project_address);
                        } else if (projectDetails?.id) {
                          fetchProjectDetails(projectDetails.id); // fallback
                        }
                        setDialogOpen(false);
                      }
                    }}
                  >
                    <FormControlLabel
                      value="default"
                      control={<Radio />}
                      label="Project Address"
                    />
                    <FormControlLabel
                      value="branch"
                      control={<Radio />}
                      label="Custom Address"
                    />
                    {addressType === "branch" && (
                      <>
                        <TextField
                          label="Address"
                          multiline
                          rows={6}
                          value={selectedAddress}
                          onChange={(e) => setSelectedAddress(e.target.value)}
                          fullWidth
                        />
                        <Button
                          variant="primary"
                          className={`btn-primary`}
                          onClick={() => {
                            if (
                              !selectedAddress ||
                              selectedAddress.trim() === ""
                            ) {
                              childRef.current.triggerAlert(
                                JSON.stringify({
                                  message: "Custom address cannot be empty.",
                                  messageType: "error",
                                }),
                              );
                              return;
                            }
                            setDialogOpen(false);
                          }}
                        >
                          Update Address
                        </Button>
                      </>
                    )}
                  </RadioGroup>
                </DialogContent>
              </Dialog>

              {/* <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Project
                  </InputLabel>
                  <Select
                    labelId="Select Project"
                    id="demo-simple-select"
                    value={project}
                    label="Select Project"
                    onChange={(event) => {
                      handleProjectChange(event.target.value);
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 450,
                        },
                      },
                    }}
                    onOpen={handleCompanyFieldClick}
                    open={autoOpen}
                    onClose={handleAutoCompleteClose}
                  >
                    {ProjectNameList.map((row, index) => (
                      <MenuItem value={row.id} key={index}>
                        {row.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography className="invalid-feedback">
                    {errors.intProjectID?.message}
                  </Typography>
                </FormControl>
              </Grid> */}

              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth>
                  <Autocomplete
                    options={
                      Array.isArray(ProjectNameList) ? ProjectNameList : []
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      Array.isArray(ProjectNameList)
                        ? ProjectNameList.find(
                            (p) => String(p.id) === String(project),
                          ) || null
                        : null
                    }
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue === "object") {
                        handleProjectChange(newValue.id);
                      } else {
                        setProject("");
                        setValue("intProjectID", "");
                        setProjectDetails({});
                        setSelectedAddress("");
                        setAddressType("");
                      }
                    }}
                    onOpen={handleCompanyFieldClick}
                    open={autoOpen}
                    onClose={handleAutoCompleteClose}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Project"
                        placeholder="Search Project"
                        variant="outlined"
                      />
                    )}
                  />
                  <Typography className="invalid-feedback">
                    {errors.intProjectID?.message}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container className="pomargin table_po">
              <Grid container spacing={2}>
                {/* Vendor Details */}
                <Grid item className="form-label" xs={12} lg={4} md={4}>
                  <Grid className="info_details">
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "20px",
                      }}
                    >
                      Bill To
                    </Typography>
                    {vendorDetails.hasOwnProperty("name") && (
                      <>
                        <Typography className="companyna">
                          {vendorDetails.name}
                        </Typography>
                        <Typography>{vendorDetails.mobile_no}</Typography>
                        <Typography>
                          {vendorDetails.street_address}, {vendorDetails.city}
                        </Typography>
                        <Typography>
                          {vendorDetails.pincode} {vendorDetails.state}
                        </Typography>
                        <Typography>India</Typography>
                        <Typography>GSTIN {vendorDetails.gst}</Typography>
                      </>
                    )}
                  </Grid>
                </Grid>

                {/* Project Details */}
                {/* <Grid item className="form-label" xs={12} lg={4} md={4}>
                  {projectDetails.hasOwnProperty("name") && (
                    <Grid className="info_details">
                      <Typography variant="h6" sx={{ fontSize: "20px" }}>
                        Place of Supply:
                      </Typography>
                      <Typography className="companyna">
                        {projectDetails.project_address}
                      </Typography>
                      <Typography>{projectDetails.city}</Typography>
                      <Typography>
                        {projectDetails.pincode} {projectDetails.state}
                      </Typography>
                      <Typography>India</Typography>
                    </Grid>
                  )}
                </Grid> */}

                <Grid item className="form-label" xs={12} lg={4} md={4}>
                  <Grid className="info_details">
                    <Typography variant="h6" sx={{ fontSize: "20px" }}>
                      Place of Supply:
                    </Typography>

                    {addressType == "default" && projectDetails?.name ? (
                      <>
                        <Typography className="companyna">
                          {projectDetails.project_address}
                        </Typography>

                        <Typography>{projectDetails?.city}</Typography>

                        <Typography>{projectDetails?.state}</Typography>

                        <Typography>India</Typography>
                      </>
                    ) : (
                      <>
                        {selectedAddress?.split(",").map((line, index, arr) => (
                          <Typography key={index}>
                            {line.trim()}
                            {index < arr.length - 1 ? "," : ""}
                            <br />
                          </Typography>
                        ))}{" "}
                      </>
                    )}
                  </Grid>
                </Grid>

                {/* Other Details */}
                <Grid
                  item
                  xs={12}
                  lg={4}
                  md={4}
                  sx={{ border: "1px solid black", mt: 2 }}
                >
                  {/* Supplier Ref./Quotation No. */}
                  <Grid
                    container
                    spacing={1}
                    justifyContent="center"
                    className="po_leble"
                  >
                    <Grid item xs={12}>
                      <Typography>Supplier Ref :</Typography>
                      <TextField
                        fullWidth
                        size="small"
                        name="familyname"
                        type="text"
                        {...register("txtQuotationNo")}
                      />
                    </Grid>
                  </Grid>

                  {/* Purchase Classification */}
                  <Grid
                    container
                    spacing={1}
                    justifyContent="center"
                    className="po_leble"
                  >
                    <Grid item xs={12}>
                      <Typography>
                        {orderType == 1
                          ? "PO Classification"
                          : orderType == 2
                            ? "WO Classification"
                            : "Purchase Classification"}
                      </Typography>

                      <FormControl fullWidth size="small">
                        <Select
                          value={purchaseClassify}
                          onChange={(e) => {
                            setPurchaseClassify(e.target.value);
                            setValue("txtPurchaseClassify", e.target.value);
                          }}
                        >
                          {Purchase.map((row, index) => (
                            <MenuItem value={row.id} key={index}>
                              {row.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <Typography className="invalid-feedback">
                          {errors.txtPurchaseClassify?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* Site Engineer */}
                  <Grid
                    container
                    spacing={1}
                    justifyContent="center"
                    className="po_leble"
                  >
                    <Grid item xs={12}>
                      <Typography>Site Engineer:</Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          value={txtSiteEng || ""}
                          label="Site Engineer"
                          onChange={(e) => {
                            setTextSiteEng(e.target.value);
                            findPhoneNumber(e.target.value);
                            setValue("txtSiteEng", e.target.value);
                          }}
                        >
                          {siteEngineer && siteEngineer.length > 0 ? (
                            siteEngineer.map((row, index) => (
                              <MenuItem value={row.id} key={index}>
                                {row.name}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem>No data found</MenuItem>
                          )}
                        </Select>
                        <Typography className="invalid-feedback">
                          {errors.txtPurchaseClassify?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* Site Engineer Contact */}
                  <Grid
                    container
                    spacing={1}
                    justifyContent="center"
                    className="po_leble"
                  >
                    <Grid item xs={12}>
                      <Typography>Contact:</Typography>
                      <TextField
                        fullWidth
                        size="small"
                        name="siteEngineerContact"
                        type="text"
                        {...register("txtSiteEngContact")}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item className="form-lable" xs={12} lg={12} md={12}>
                <table className={`table`}>
                  <thead>
                    <th style={{ width: "5%" }}>
                      <Typography>S. No.</Typography>
                    </th>
                    <th style={{ width: "28%" }}>
                      <Typography>Description</Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>UNO </Typography>
                    </th>
                    <th style={{ width: "12%" }}>
                      <Typography>Rate </Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>Discount</Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>GST </Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>Total Amount Without GST</Typography>
                    </th>
                    <th style={{ width: "5%" }} className="add_button">
                      <Tooltip title="Add New" arrow>
                        <Button
                          variant="outlined"
                          onClick={handleServiceAdd}
                          startIcon={<AddIcon />}
                          color="success"
                        ></Button>
                      </Tooltip>
                    </th>
                  </thead>
                  <tbody>
                    {serviceList1?.map((singleService, index) => (
                      <tr className="table_padding">
                        <td className={`text-center`}>
                          <Typography>{index + 1}</Typography>
                        </td>
                        <td className="po_leble">
                          <TextField
                            name="txtItemName"
                            type="text"
                            id="txtItemName"
                            value={singleService.txtItemName}
                            onChange={(e) => handleServiceChange(e, index)}
                            required
                            fullWidth
                            multiline
                            // or whatever max you prefer
                            style={{ width: "100%" }}
                          />
                        </td>
                        <td className="po_leble">
                          <Select
                            name="txtUnits"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            // value={singleService?.txtUnits}
                            defaultValue={singleService?.txtUnits}
                            onChange={(e) => {
                              setUnitsFlag(true);
                              handleServiceChange(e, index);
                            }}
                          >
                            {unitsList.length > 0 &&
                              unitsList.map((row, index) => (
                                <MenuItem value={row.id} key={index}>
                                  {row.name}
                                </MenuItem>
                              ))}
                          </Select>
                          {/* {unitsFlag && ( */}
                          <TextField
                            name="intQuantity"
                            type="number"
                            value={singleService.intQuantity}
                            onChange={(e) => handleServiceChange(e, index)}
                            inputProps={{
                              min: 0,
                              step: "any",
                            }}
                          />
                          {/* )} */}
                        </td>
                        <td className="po_leble">
                          <RadioGroup
                            row
                            name="blnWithGST"
                            value={singleService.blnWithGST === true ? "with" : "without"}
                            onChange={(e) => {
                              const synthEvent = {
                                target: {
                                  name: "blnWithGST",
                                  value: e.target.value === "with",
                                },
                              };
                              handleServiceChange(synthEvent, index);
                            }}
                            style={{ marginBottom: "4px" }}
                          >
                            <FormControlLabel
                              value="without"
                              control={<Radio size="small" style={{ padding: 4 }} />}
                              label={<span style={{ fontSize: '11px' }}>Without GST</span>}
                              style={{ marginRight: 8 }}
                            />
                            <FormControlLabel
                              value="with"
                              control={<Radio size="small" style={{ padding: 4 }} />}
                              label={<span style={{ fontSize: '11px' }}>With GST</span>}
                            />
                          </RadioGroup>
                          <TextField
                            name="intAmount"
                            type="number"
                            value={singleService.intAmount}
                            onChange={(e) => handleServiceChange(e, index)}
                            style={{ width: "100%" }}
                          />
                        </td>

                        {/* ── Per-item Discount ── */}
                        <td className="po_leble">
                          <FormControl
                            fullWidth
                            size="small"
                            style={{ marginBottom: 4 }}
                          >
                            <Select
                              displayEmpty
                              name="txtDiscountType"
                              value={singleService.txtDiscountType || ""}
                              onChange={(e) => handleServiceChange(e, index)}
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              <MenuItem value="percentage">
                                Percentage (%)
                              </MenuItem>
                              <MenuItem value="fixed">(Rs. )Fixed</MenuItem>
                            </Select>
                          </FormControl>
                          {singleService.txtDiscountType && (
                            <TextField
                              name="fltDiscountValue"
                              type="number"
                              size="small"
                              placeholder={
                                singleService.txtDiscountType === "percentage"
                                  ? "0–100"
                                  : "Rs. Amount"
                              }
                              value={singleService.fltDiscountValue || ""}
                              inputProps={{
                                min: 0,
                                max:
                                  singleService.txtDiscountType === "percentage"
                                    ? 100
                                    : undefined,
                                step: "any",
                              }}
                              error={
                                singleService.txtDiscountType ===
                                  "percentage" &&
                                parseFloat(singleService.fltDiscountValue) > 100
                              }
                              helperText={
                                singleService.txtDiscountType ===
                                  "percentage" &&
                                parseFloat(singleService.fltDiscountValue) > 100
                                  ? "Max 100%"
                                  : ""
                              }
                              onChange={(e) => handleServiceChange(e, index)}
                              onKeyDown={(e) =>
                                ["e", "E", "-", "+"].includes(e.key) &&
                                e.preventDefault()
                              }
                              style={{ width: "100%" }}
                            />
                          )}
                        </td>

                        <td className="po_leble">
                          {singleService.blnWithGST !== true ? (
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                name="intGST"
                                id="demo-simple-select"
                                defaultValue={parseInt(singleService?.intGST)}
                                onChange={(e) => {
                                  handleServiceChange(e, index);
                                }}
                              >
                                {GST_RATES.map((r) => (
                                  <MenuItem value={`${r}`} key={r}>
                                    GST {r}%
                                  </MenuItem>
                                ))}
                              </Select>
                              <Typography className="invalid-feedback">
                                {errors.intGST?.message}
                              </Typography>
                            </FormControl>
                          ) : (
                            <Typography textAlign="center" sx={{ display: 'block', padding: '8px', color: '#666' }}>-</Typography>
                          )}
                        </td>

                        {/* <td className="po_leble">
                          <Typography>{singleService.intSGST}</Typography>
                        </td> */}
                        <td className="po_leble">
                          <Typography textAlign="right">
                            {isNaN(singleService.intLineItemTotalWithoutGST)
                              ? `0.00`
                              : twoDecimal(
                                  singleService.intLineItemTotalWithoutGST,
                                )}
                          </Typography>
                        </td>
                        <td className="cancel_button">
                          {serviceList1.length !== 1 && (
                            <Button
                              variant="outlined"
                              onClick={(e) => {
                                handleServiceChange(e, index);
                                handleServiceRemove(index);
                              }}
                              startIcon={<DeleteIcon />}
                              color="error"
                            ></Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tbody className="tbody_col">
                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={5}>
                        <Typography>Total amount</Typography>
                      </td>
                      <td colSpan={2}>
                        <Typography value={total}>
                          {isNaN(total) ? `0.00` : twoDecimal(total)}
                        </Typography>
                      </td>
                    </tr>
                    {vendorDetails.state != "TamilNadu" ? (
                      <>
                        <tr className="table_padding_40">
                          <td className={`text-center`}>
                            <Typography></Typography>
                          </td>
                          <td colSpan={5}>
                            <Typography>IGST </Typography>
                          </td>
                          <td colSpan={2}>
                            <Typography value={totalIgst}>
                              {isNaN(totalIgst)
                                ? `0.00`
                                : twoDecimal(totalIgst)}
                            </Typography>
                          </td>
                        </tr>
                      </>
                    ) : (
                      <>
                        <tr className="table_padding_40">
                          <td className={`text-center`}>
                            <Typography></Typography>
                          </td>
                          <td colSpan={5}>
                            <Typography>CGST </Typography>
                          </td>
                          <td colSpan={2}>
                            <Typography value={totalCgst}>
                              {isNaN(totalCgst)
                                ? `0.00`
                                : twoDecimal(totalCgst)}
                            </Typography>
                          </td>
                        </tr>
                        <tr className="table_padding_40">
                          <td className={`text-center`}>
                            <Typography></Typography>
                          </td>
                          <td colSpan={5}>
                            <Typography>SGST </Typography>
                          </td>
                          <td colSpan={2}>
                            <Typography value={totalSgst}>
                              {isNaN(totalSgst)
                                ? `0.00`
                                : twoDecimal(totalSgst)}
                            </Typography>
                          </td>
                        </tr>
                      </>
                    )}
                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={3}>
                        <Typography>Transport Charges</Typography>
                      </td>
                      <td className="po_leble">
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            name="intTransportGST"
                            id="demo-simple-select"
                            {...register("intTransportGST")}
                            value={transportGST}
                            onChange={(e) => {
                              setValue("intTransportGST", e.target.value);
                              setTransportGST(e.target.value);
                              handleTransportCharge(
                                transportAmount,
                                e.target.value,
                              );
                            }}
                          >
                            {GST_RATES.map((r) => (
                              <MenuItem value={`${r}`} key={r}>
                                GST {r}%
                              </MenuItem>
                            ))}
                          </Select>
                          <Typography className="invalid-feedback">
                            {errors.intGST?.message}
                          </Typography>
                        </FormControl>
                      </td>
                      <td className="po_leble">
                        <TextField
                          name="intTransportAmount"
                          type="number"
                          value={transportAmount}
                          {...register("intTransportAmount")}
                          onChange={(e) => {
                            setTransportAmount(e.target.value);
                            handleTransportCharge(e.target.value, transportGST);
                          }}
                          inputProps={{
                            min: 0,
                            step: "any",
                          }}
                        />
                      </td>
                      <td colSpan={2}>
                        <Typography value={transportCharge}>
                          {isNaN(transportCharge)
                            ? `0.00`
                            : twoDecimal(transportCharge)}
                        </Typography>
                      </td>
                    </tr>

                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={5}>
                        <Typography>Total amount with GST </Typography>
                      </td>
                      <td colSpan={2}>
                        <Typography value={totalamount}>
                          {isNaN(totalamount)
                            ? `0.00`
                            : twoDecimal(totalamount)}
                        </Typography>
                      </td>
                    </tr>

                    {/* <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={7}>
                        <Typography>Rounded off </Typography>
                      </td>
                      <td colSpan={7}>
                        <Typography value={totalamount}>
                          {isNaN(totalamount)
                            ? `0.00`
                            : calculateRoundingDifference(totalamount)}
                        </Typography>
                      </td>
                    </tr> */}
                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={5}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "20px",
                          }}
                        >
                          Total Payable Amount (Rs.)
                        </Typography>
                      </td>
                      <td colSpan={2}>
                        <Typography
                          value={totalamount}
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "20px",
                          }}
                        >
                          {isNaN(totalamount)
                            ? `0.00 /-`
                            : `${roundUpToInteger(totalamount)} /-`}
                        </Typography>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
            <div className="empty-space-20"></div>
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
              textAlign="left"
              className="po_lebleterm"
            >
              <FormControl className="form_control" sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-checkbox-label">
                  Terms & Conditions
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  value={termsHeading}
                  onChange={handleChangeterm}
                  input={<OutlinedInput label="Terms & Conditions" />}
                  MenuProps={MenuProps}
                >
                  {termsNames.map((terms) => (
                    <MenuItem key={terms.title} value={terms.id}>
                      <ListItemText primary={terms.title} onClick={() => {}} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {termsDescription && (
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                textAlign={`right`}
                display={`flex`}
                justifyContent={`flex-end`}
              >
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  maxRows={6}
                  // label="Description"
                  {...register("txtTerms")}
                />
              </Grid>
            )}

            <Grid></Grid>
            <Grid item className="form-lable" xs={12} lg={4} md={4}>
              <label> Document : </label>
              <br />
              <small className="" style={{ fontSize: "12px" }}>
                Allowed Only *.jpeg, *.jpg, *.png, *.pdf
              </small>
              <br></br>
              <Box display={`flex`}>
                <Button variant="contained" component="label">
                  <input
                    id="agreementdocument"
                    name="agreementdocument"
                    type="file"
                    accept="image/jpg,image/jpeg,image/png,application/pdf"
                    fullWidth
                    {...register("txtFile")}
                    onChange={(e) => {
                      uploadagreement(e);
                    }}
                  />
                </Button>
                {baseuploadagreement != "" && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setIsCancelPopup(true)}
                    style={{ marginLeft: "10px" }}
                  >
                    Remove
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid></Grid>
            {baseuploadagreement != "" && (
              <Grid item className="form-lable" xs={12} lg={12} md={12}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="h6">Document</Typography>

                  {baseuploadagreement.endsWith(".pdf") ? (
                    <iframe
                      src={baseuploadagreement}
                      title="document"
                      width="100%"
                      height="600"
                    ></iframe>
                  ) : baseuploadagreement.startsWith(
                      "data:application/pdf;base64,",
                    ) ? (
                    <iframe
                      src={`data:application/pdf;base64,${
                        baseuploadagreement.split(",")[1]
                      }`}
                      title="document"
                      width="100%"
                      height="600"
                    ></iframe>
                  ) : (
                    <img
                      src={baseuploadagreement}
                      alt="document"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                </Grid>
              </Grid>
            )}
            <div className="empty-space-20"></div>
            <Grid item xs={12} md={12} lg={12} textAlign="right">
              <Button variant="primary" className={`btn-primary`} type="submit">
                Submit
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <Dialog
        open={isCancelPopup}
        onClose={() => setIsCancelPopup(false)}
        maxWidth="xl"
      >
        <DialogTitle sx={{ backgroundColor: "#FFF2D7" }}>
          <Typography
            variant="h5"
            style={{
              color: "#FF6868",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Warning!!
          </Typography>
        </DialogTitle>
        <DialogContent style={{ padding: "16px" }}>
          <Typography variant="h6">
            Would you like to remove the attachment?
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#f44336", fontWeight: "bold" }}
          >
            **This step cannot be undone
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", padding: "16px" }}>
          <Button color="success" onClick={handleCancelFile}>
            Yes
          </Button>
          <Button color="error" onClick={() => setIsCancelPopup(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <>
        <NavigationGuard />
      </>
    </Layout>
  );
}

export default PurchaseOrderEdit;
